// @ts-nocheck
/**
 * 分解テーブル
 *
 * カードを分解した際に得られる素材量を定義
 * レアリティごとに異なる素材獲得量を設定
 */

/**
 * レアリティ別分解量
 */
export const DECOMPOSITION_TABLE = {
  C: {
    attributeMaterial: 20,   // 属性素材
    categoryMaterial: 3,     // カテゴリ素材
    genericMaterial: 5,      // 汎用素材（魔力の核）
    rarityFragment: 2,       // レアリティ破片
  },
  UC: {
    attributeMaterial: 35,
    categoryMaterial: 5,
    genericMaterial: 10,
    rarityFragment: 3,
  },
  R: {
    attributeMaterial: 50,
    categoryMaterial: 8,
    genericMaterial: 15,
    rarityFragment: 5,
  },
  SR: {
    attributeMaterial: 80,
    categoryMaterial: 12,
    genericMaterial: 25,
    rarityFragment: 8,
  },
  SSR: {
    attributeMaterial: 100,
    categoryMaterial: 20,
    genericMaterial: 40,
    rarityFragment: 12,
  },
  UR: {
    attributeMaterial: 150,
    categoryMaterial: 40,
    genericMaterial: 60,
    rarityFragment: 20,
  },
  LR: {
    attributeMaterial: 200,
    categoryMaterial: 60,
    genericMaterial: 100,
    rarityFragment: 30,
  },
  MR: {
    attributeMaterial: 300,
    categoryMaterial: 100,
    genericMaterial: 150,
    rarityFragment: 50,
  },
  EX: {
    attributeMaterial: 500,
    categoryMaterial: 200,
    genericMaterial: 250,
    rarityFragment: 100,
  },
  GR: {
    attributeMaterial: 1000,
    categoryMaterial: 500,
    genericMaterial: 500,
    rarityFragment: 200,
  },
};

/**
 * カテゴリ→素材名マッピング
 *
 * crafting_system_design.md に基づく新設計:
 * - 種族系: カテゴリ → ノーマル素材
 * - 派閥系: カテゴリ → ノーマル素材
 */
export const CATEGORY_MATERIAL_MAP = {
  // ========================================
  // 種族系 (13グループ)
  // ========================================

  // --- ドラゴン系 ---
  'ドラゴン': '竜鱗',
  'ワイバーン': '竜鱗',
  'サラマンダー': '竜鱗',

  // --- ビースト系 ---
  'ビースト': '獣の牙',
  'ビースト・猫': '獣の牙',
  'ビースト・狸': '獣の牙',
  'ビースト・狼': '獣の牙',
  'ビースト・フロッグ': '獣の牙',
  'ビースト・鹿': '獣の牙',
  'ビースト・イノシシ': '獣の牙',
  '幻獣': '獣の牙',

  // --- スピリット系 ---
  'スピリット': '霊魂のエーテル',

  // --- 鳥系 ---
  '鳥': '風切り羽',
  '鳥・カラス': '風切り羽',
  '鳥・カモメ': '風切り羽',

  // --- ゴーレム系 ---
  'ゴーレム': '魔力のコア',
  'ガーディアン': '魔力のコア',

  // --- プラント系 ---
  'プラント': '生命の種子',

  // --- スライム系 ---
  'スライム': '粘液核',
  'コア・ビースト': '粘液核',

  // --- 虫類 ---
  'インセクト': '虫殻の欠片',
  'インセクト・アリ': '虫殻の欠片',
  'インセクト・ビートル': '虫殻の欠片',
  'インセクト・蜘蛛': '虫殻の欠片',
  'インセクト・蛾': '虫殻の欠片',
  'インセクト・アメンボ': '虫殻の欠片',

  // --- 機械 ---
  'マシン': '機械部品',

  // --- 魔法生物 ---
  '魔族': '魔力結晶',
  '魔導士': '魔力結晶',
  'ウィザード': '魔力結晶',

  // --- 霊体 ---
  'ゴースト': '怨念の残滓',
  'スケルトン': '怨念の残滓',

  // --- 爬虫類 ---
  'スネーク': '蛇皮',

  // --- ヒューマノイド ---
  'ヒューマノイド': '人型の証',
  'カイザー': '人型の証',
  'ソルジャー': '人型の証',

  // ========================================
  // 派閥系 (15グループ)
  // ========================================

  // --- ソウルカース ---
  'ソウルカース': '呪縛の鎖',

  // --- タイドウェーブ ---
  'タイドウェーブ': '潮流の結晶',
  'マーメイド': '潮流の結晶',
  'リヴァイアサン': '潮流の結晶',

  // --- パペットマスター ---
  'パペットマスター': '操糸',

  // --- ダークドウェラ ---
  'ダークドウェラ': '深闇の欠片',
  'シャドウ': '深闇の欠片',

  // --- マグマフォージ ---
  'マグマフォージ': '溶岩核',

  // --- 蛮族 ---
  '蛮族': '蛮勇の証',

  // --- エクラシア ---
  'エクラシア': '時の歯車',
  'プリンセス': '時の歯車',

  // --- 飛翔連合 ---
  'スカイレジェンド': '天空の羽根',
  'ウィング・トリビューン': '天空の羽根',
  'フェニックス': '天空の羽根',

  // --- 深淵勢力 ---
  'アビスソウル': '深淵の闘気',
  'ディープシャドウ': '深淵の闘気',
  'デーモン': '深淵の闘気',
  'ブラック・オラクル': '深淵の闘気',

  // --- 虚蝕 ---
  '虚蝕': '虚無の欠片',

  // --- 聖光 ---
  'ルミナフォース': '聖光の結晶',
  '天使': '聖光の結晶',
  'エンジェル': '聖光の結晶',

  // --- 時空 ---
  'トラベラー': '時空の砂',

  // --- 毒牙 ---
  'ポイズンウェイル': '毒腺',

  // --- 拘束 ---
  '鎖': '鎖の欠片',

  // --- 宿敵 ---
  'ライバル': '闘志の欠片',
};

/**
 * 属性→素材名マッピング
 */
export const ATTRIBUTE_MATERIAL_MAP = {
  '炎': '炎の結晶',
  '水': '水の結晶',
  '光': '光の結晶',
  '闇': '闇の結晶',
  '原始': '原始の結晶',
  '未来': '未来の結晶',
};

/**
 * レアリティ→破片名マッピング
 */
// 実際のレアリティシステム: C, UC, R, SR, UR, HR, SEC, ALT, SP, GR
export const RARITY_FRAGMENT_MAP = {
  C: 'C破片',
  UC: 'UC破片',
  R: 'R破片',
  SR: 'SR破片',
  UR: 'UR破片',
  HR: 'HR破片',
  SEC: 'SEC破片',
  ALT: 'ALT破片',
  SP: 'SP破片',
  GR: 'GR破片',
};

/**
 * 市場価格ボーナス閾値
 * 高価なカードは追加の素材を獲得
 */
export const MARKET_BONUS_THRESHOLDS = [
  { minValue: 50000, material: '秘宝の欠片', count: 3 },
  { minValue: 20000, material: '秘宝の欠片', count: 2 },
  { minValue: 10000, material: '秘宝の欠片', count: 1 },
  { minValue: 5000, material: '魔力の核', count: 10 },
];

/**
 * カード基本価値（分解計算用）
 */
export const BASE_CARD_VALUES = {
  C: 100,
  UC: 300,
  R: 800,
  SR: 2000,
  SSR: 5000,
  UR: 10000,
  LR: 25000,
  MR: 50000,
  EX: 100000,
  GR: 250000,
};

/**
 * 分解量を取得
 *
 * @param {string} rarity - レアリティ
 * @returns {Object|null} 分解量
 */
export function getDecompositionYield(rarity) {
  return DECOMPOSITION_TABLE[rarity] || null;
}

/**
 * カテゴリから素材名を取得
 *
 * @param {string|string[]} category - カテゴリ（【】付きでも可、配列も可）
 * @returns {string|null} 素材名
 */
export function getCategoryMaterial(category) {
  if (!category) return null;

  // 配列の場合は最初の要素を使用
  const categoryStr = Array.isArray(category) ? category[0] : category;
  if (!categoryStr || typeof categoryStr !== 'string') return null;

  // 【】を除去してカテゴリ名を取得
  const categoryName = categoryStr.replace(/【|】/g, '');

  return CATEGORY_MATERIAL_MAP[categoryName] || null;
}

/**
 * 属性から素材名を取得
 *
 * @param {string} attribute - 属性
 * @returns {string|null} 素材名
 */
export function getAttributeMaterial(attribute) {
  return ATTRIBUTE_MATERIAL_MAP[attribute] || null;
}

/**
 * レアリティから破片名を取得
 *
 * @param {string} rarity - レアリティ
 * @returns {string|null} 破片名
 */
export function getRarityFragment(rarity) {
  return RARITY_FRAGMENT_MAP[rarity] || null;
}

/**
 * 市場価格ボーナスを計算
 *
 * @param {number} marketValue - 市場価格
 * @returns {{ material: string, count: number }|null} ボーナス素材
 */
export function calculateMarketBonus(marketValue) {
  for (const threshold of MARKET_BONUS_THRESHOLDS) {
    if (marketValue >= threshold.minValue) {
      return {
        material: threshold.material,
        count: threshold.count,
      };
    }
  }

  return null;
}

/**
 * カードの基本価値を取得
 *
 * @param {string} rarity - レアリティ
 * @returns {number} 基本価値
 */
export function getBaseCardValue(rarity) {
  return BASE_CARD_VALUES[rarity] || 100;
}

export default {
  DECOMPOSITION_TABLE,
  CATEGORY_MATERIAL_MAP,
  ATTRIBUTE_MATERIAL_MAP,
  RARITY_FRAGMENT_MAP,
  MARKET_BONUS_THRESHOLDS,
  BASE_CARD_VALUES,
  getDecompositionYield,
  getCategoryMaterial,
  getAttributeMaterial,
  getRarityFragment,
  calculateMarketBonus,
  getBaseCardValue,
};
